"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.addBom = addBom;
exports.dataCheck = dataCheck;
exports.del = del;
exports.findByFlowInstId = findByFlowInstId;
exports.findById = findById;
exports.getAssemblyBomVersionList = getAssemblyBomVersionList;
exports.getAssemblyMaterialList = getAssemblyMaterialList;
exports.getBomVersion = getBomVersion;
exports.getList = getList;
exports.importTemplate = importTemplate;
exports.submit = submit;
exports.update = update;
exports.updateBom = updateBom;
var _request = _interopRequireDefault(require("@utils/request"));
var _cloud = require("@utils/cloud");
// 分页
function getList(query) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/list',
    method: 'POST',
    data: query
  });
}

// id 查询
function findById(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/' + id,
    method: 'get'
  });
}
// 流程实例 id 查询
function findByFlowInstId(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/findByFlowInstId/' + id,
    method: 'get'
  });
}
// 修改
function update(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom',
    method: 'put',
    data: data
  });
}

// 保存
function add(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom',
    method: 'post',
    data: data
  });
}

// 提交
function submit(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/submit',
    method: 'post',
    data: data
  });
}

//删除
function del(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/del',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 保存
function addBom(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/addBom',
    method: 'post',
    data: data
  });
}

// 修改
function updateBom(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/updateBom',
    method: 'put',
    data: data
  });
}

//导入模板
function importTemplate() {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/importTemplate',
    method: 'get'
  });
}

// 查询重复版本
function getBomVersion(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/getBomVersion',
    method: 'post',
    data: data
  });
}

// 获取重复版本
function getAssemblyBomVersionList(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/getAssemblyBomVersionList',
    method: 'post',
    data: data
  });
}

// 获取重复版本
function getAssemblyMaterialList(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/getAssemblyMaterialList',
    method: 'post',
    data: data
  });
}

// 数据校验
function dataCheck() {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/mdg/bom/dataCheck',
    method: 'post'
  });
}